import React from 'react';
import { Mail, Phone, MapPin, Facebook, Linkedin, Twitter } from 'lucide-react';
import { mockData } from '../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Home', id: 'home' },
    { label: 'About Us', id: 'about' },
    { label: 'Services', id: 'services' },
    { label: 'Projects', id: 'projects' },
    { label: 'Customers & Partners', id: 'customers-partners' }
  ];

  const services = [
    'ICT Consultancy',
    'Solar PV Systems',
    'Water Distribution',
    'Sanitation Services'
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0D2C59] text-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#74C65A]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#74C65A]/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 lg:px-8 py-12 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="space-y-4">
            <img
              src="/elzalira-logo.png"
              alt="Elzalira Logo"
              className="h-20 w-auto mb-4"
            />
            <p className="text-slate-300 text-sm leading-relaxed font-semibold">
              Driving sustainable development through innovation
            </p>
            <div className="flex space-x-3">
              <button className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm hover:bg-[#74C65A] flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                <Facebook className="w-5 h-5" />
              </button>
              <button className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm hover:bg-[#74C65A] flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                <Linkedin className="w-5 h-5" />
              </button>
              <button className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm hover:bg-[#74C65A] flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                <Twitter className="w-5 h-5" />
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#74C65A]">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-slate-300 hover:text-[#74C65A] transition-colors text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#74C65A]">Our Services</h3>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index} className="text-slate-300 text-sm">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#74C65A]">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#74C65A] flex-shrink-0 mt-1" />
                <p className="text-slate-300 text-sm">{mockData.company.address}</p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#74C65A] flex-shrink-0" />
                <p className="text-slate-300 text-sm">{mockData.company.phone}</p>
              </div>
              <div className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-[#74C65A] flex-shrink-0 mt-1" />
                <div className="text-slate-300 text-sm">
                  <p>{mockData.company.email}</p>
                  <p>{mockData.company.adminEmail}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-300 text-sm">
              © {currentYear} {mockData.company.name}. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <button className="text-slate-300 hover:text-[#74C65A] text-sm transition-colors">
                Privacy Policy
              </button>
              <button className="text-slate-300 hover:text-[#74C65A] text-sm transition-colors">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};